export default __webpack_public_path__ + "static/media/Q2_1_resized.fa9d9966.jpg";